// extracted by mini-css-extract-plugin
export default {"card":"Zg3Juo","highlight":"F9vzxL","countImage":"cVdPCu","oldPrice":"MTsTAr","mostPopImage":"qGKb2U","circle":"XtmbHH"};